<script setup lang="ts">
import { NuxtLink } from '#components';
import dayjs from 'dayjs';
import type { PropType } from '@vue/runtime-core';
import type { NewsItem } from '~/composables/useNewsData';

defineProps({
  item: {
    type: Object as PropType<NewsItem>,
    required: true,
  },
});

const { convertAssetUrl } = useCms();

function formatDate(date?: string | number | Date) {
  return date ? dayjs(date).format('YYYY . MM') : '-';
}
</script>

<template>
  <div class="news-item">
    <div class="row align-items-center gx-6">
      <div class="col-md-6">
        <img
          class="featuredImage"
          :src="
            convertAssetUrl(item.featuredImage, { key: 'large' }) ||
            'https://placehold.co/604x377?text=604x377\\n(16:10)'
          "
          alt="Featured Image"
        />
      </div>
      <div class="col-md-6">
        <div class="date mt-3">{{ formatDate(item.date_published) }}</div>
        <p class="title my-2">{{ item.title }}</p>
        <CtaButton
          :tag="NuxtLink"
          class="viewBtn my-4"
          :to="`/news/${item.id}`"
        >
          View
        </CtaButton>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '@/assets/css/variables.scss';
@import 'bootstrap/scss/functions';
@import 'bootstrap/scss/variables';
@import 'bootstrap/scss/mixins';

.news-item {
  padding: 90px 0;
  border-bottom: 1px solid black;
  font-size: 18px;
  font-weight: 500;
}

.featuredImage {
  width: 100%;
  object-fit: cover;
  aspect-ratio: 16 / 10;
  border-radius: 10px;

  @include media-breakpoint-down(md) {
    border-radius: 5px;
  }
}

.title {
  font-size: 20px;
  font-weight: 600;
}

.viewBtn {
  @include media-breakpoint-down(md) {
    border-radius: 5px;
    display: block;
    text-align: center;
    margin-left: 48px;
    margin-right: 48px;
  }
}
</style>
